// styles
import styles from './counter.module.scss';
import { Button as GddsButton } from '@geberit/gdds';

// types
import { type BasketItem } from 'components/ShoppingBasket/reducer.types';

// components
import { BUTTON_TYPES, Button } from 'components/Button/Button';

// utils
import { useXy } from 'utils/hooks/use-xy';
import { useTranslationFunction } from 'utils/hooks/use-translations';

type CounterProps = {
  countInput: string | number;
  decreaseItem: () => void;
  increaseItem: () => void;
  setItem: (e: React.ChangeEvent<HTMLInputElement>) => void;
  article?: BasketItem;
  className?: string | null;
  onInputBlur?: () => void;
};

function Counter({
  className = null,
  countInput,
  decreaseItem,
  increaseItem,
  onInputBlur,
  setItem,
  article,
}: Readonly<CounterProps>) {
  const decresableDisabledClass = Number(countInput) <= 1 ? styles.disabled : '';
  const increasableDisabledClass = Number(countInput) >= 99 ? styles.disabled : '';
  const isXy = useXy();
  const translate = useTranslationFunction();

  const QuantityButton = isXy ? GddsButton : Button;

  return (
    <div className={`${styles.counter} ${className}`}>
      <QuantityButton
        symbol="minus"
        disabled={!!decresableDisabledClass || article?.isBeingUpdated}
        onClick={decreaseItem}
        aria-label={translate('arialabel_reduce_itemnumber')}
        {...(isXy
          ? {
              stylingType: 'iconFlat',
              isIcon: true,
            }
          : {
              className: `${styles.counterButton} ${styles.buttonDecrease} ${decresableDisabledClass}`,
              type: BUTTON_TYPES.PLAIN,
            })}
      />

      <input type="text" value={countInput} onChange={setItem} onBlur={onInputBlur} />
      <QuantityButton
        symbol="plus"
        disabled={!!increasableDisabledClass || article?.isBeingUpdated}
        onClick={increaseItem}
        aria-label={translate('arialabel_increase_itemnumber')}
        {...(isXy
          ? {
              stylingType: 'iconFlat',
              isIcon: true,
            }
          : {
              className: `${styles.counterButton} ${styles.buttonIncrease} ${increasableDisabledClass}`,
              type: BUTTON_TYPES.PLAIN,
            })}
      />
    </div>
  );
}

export default Counter;
